import { ListPayformsComponent } from './components/list-payforms/list-payforms.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleCheckGuard } from './guards/role-check-guard';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { RouterUriComponents } from './enums/router-uri-components.enum';
import { NotAuthorizedRedirectGuard } from './guards/not-authorized-redirect.guard';
import { PayformResolver } from './resolvers/payform.resolver';

export const RouterDefinitions: Routes = [
  {
    path: RouterUriComponents.NOT_AUTHORIZED_PAGE,
    component: NotAuthorizedComponent,
    canActivate: [NotAuthorizedRedirectGuard],
  },
  {
    path: RouterUriComponents.LIST_PAYFORMS,
    component: ListPayformsComponent,
    canActivate: [RoleCheckGuard],
  },
  {
    path: RouterUriComponents.PAYFORM,
    loadChildren: () => import('app/components/payform/payform.module').then(m => m.PayformModule),
  },
  {
    path: `${RouterUriComponents.VIEW_PAYFORM}/:id`,
    loadChildren: () => import('app/components/payform/payform.module').then(m => m.PayformModule),
    resolve: { dsrPayform: PayformResolver },
  },
  {
    path: '',
    redirectTo: `/${RouterUriComponents.LIST_PAYFORMS}`,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(RouterDefinitions, { enableTracing: true })],
  exports: [RouterModule],
  providers: [RoleCheckGuard],
  declarations: [],
})
export class AppRoutingModule {}
